import { render, staticRenderFns } from "./header-calendar-area.vue?vue&type=template&id=0364beae&scoped=true&"
import script from "./header-calendar-area.vue?vue&type=script&lang=ts&"
export * from "./header-calendar-area.vue?vue&type=script&lang=ts&"
import style0 from "./header-calendar-area.vue?vue&type=style&index=0&id=0364beae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0364beae",
  null
  
)

export default component.exports